document.addEventListener('DOMContentLoaded', function() {
    const usedIds = new Set();  // Track used IDs

    // Function to get next available ID
    function getNextAvailableId() {
      let counter = 1;
      while (usedIds.has(`gift-checkbox-${counter}`)) {
        counter++;
      }
      const id = `gift-checkbox-${counter}`;
      usedIds.add(id);
      return id;
    }

    // Function to add gift to cart
    function addGiftToCart(selectedGift) {
      fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(selectedGift.dataset.variantId),
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        if (typeof upcartRefreshCart === 'function') {
          upcartRefreshCart();
        }
      })
      .catch(error => {
        console.error('Error adding gift:', error);
      });
    }

    // Function to initialize a single gift selection instance
    function initializeGiftInstance(container) {
      const giftCheckbox = container.querySelector('.gift-checkbox');
      const giftList = container.querySelector('.product__gift-list');
      const giftRadios = container.querySelectorAll('.gift-radio');
      const giftLabel = container.querySelector('label');  // Find the label in this container

      if (!giftCheckbox || !giftList || !giftRadios.length) return;

      // Remove any existing ID from the Set if we're reinitializing
      if (giftCheckbox.id && giftCheckbox.id.startsWith('gift-checkbox-')) {
        usedIds.delete(giftCheckbox.id);
      }

      // Set unique ID for this instance
      const instanceId = getNextAvailableId();
      giftCheckbox.id = instanceId;
      if (giftLabel) {
        giftLabel.setAttribute('for', instanceId);
      }

      // Set initial state of gift list based on checkbox
      giftList.style.display = giftCheckbox.checked ? 'block' : 'none';

      // Handle checkbox change
      giftCheckbox.addEventListener('change', function(event) {
        const thisContainer = event.target.closest('.product__gift-selection');
        const thisGiftList = thisContainer.querySelector('.product__gift-list');
        if (!thisGiftList) return;

        thisGiftList.style.display = event.target.checked ? 'block' : 'none';
        
        if (!event.target.checked) {
          thisContainer.querySelectorAll('.gift-radio').forEach(radio => {
            radio.checked = false;
          });
        }
      });

      // Handle radio button selection
      giftRadios.forEach(radio => {
        radio.addEventListener('change', function(event) {
          const thisContainer = event.target.closest('.product__gift-selection');
          if (!thisContainer) return;
          
          thisContainer.querySelectorAll('.gift-radio').forEach(otherRadio => {
            if (otherRadio !== event.target) {
              otherRadio.checked = false;
            }
          });
        });
      });

      return {
        checkbox: giftCheckbox,
        options: giftRadios
      };
    }

    // Function to check if gift should be added from a specific form
    function checkAndAddGift(form) {
      const giftSection = form.querySelector('.product__gift-selection');
      if (!giftSection) return;

      const giftCheckbox = giftSection.querySelector('.gift-checkbox');
      const giftOptions = giftSection.querySelectorAll('.gift-radio');

      if (giftCheckbox && giftCheckbox.checked) {
        const selectedGift = Array.from(giftOptions).find(radio => radio.checked);
        if (selectedGift) {
          // Wait for the main product to be added
          setTimeout(() => addGiftToCart(selectedGift), 500);
        }
      }
    }

    // Initialize any gift selections that exist on page load
    document.querySelectorAll('.product__gift-selection').forEach(container => {
      initializeGiftInstance(container);
    });

    // Listen for add to cart button clicks (including quick add)
    document.addEventListener('click', function(event) {
      const addToCartButton = event.target.closest('[data-add-to-cart]');
      if (!addToCartButton) return;

      const form = addToCartButton.closest('form[action="/cart/add"]');
      if (!form) return;

      // Only check for gifts, don't prevent the default submission
      // Let the theme handle the main product addition
      const giftSection = form.querySelector('.product__gift-selection');
      if (giftSection) {
        const giftCheckbox = giftSection.querySelector('.gift-checkbox');
        if (giftCheckbox && giftCheckbox.checked) {
          // Gift will be added after main product via theme:cart:add event
          return;
        }
      }
    });

    // Listen for theme cart add events to add gifts
    document.addEventListener('theme:cart:add', function(event) {
      addGiftToCart();
    });

    function addGiftToCart() {
      const giftCheckbox = document.querySelector('.gift-checkbox:checked');
      if (!giftCheckbox) return;

      const giftVariantId = giftCheckbox.value;
      if (!giftVariantId) return;

      // Use upcart API if available, otherwise fallback to fetch
      if (typeof window.upcart !== 'undefined' && window.upcart.add) {
        // Use upcart's add method
        window.upcart.add([{
          id: parseInt(giftVariantId, 10),
          quantity: 1,
          properties: {
            '_gift': 'true'
          }
        }]).then(response => {
        }).catch(err => {
          console.error('Error adding gift via upcart:', err);
        });
      } else {
        // Fallback to standard fetch
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: giftVariantId,
            quantity: 1,
            properties: {
              '_gift': 'true'
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          // Refresh cart with upcart if available
          if (typeof upcartRefreshCart === 'function') {
            upcartRefreshCart();
          }
        })
        .catch(error => {
          console.error('Error adding gift to cart:', error);
        });
      }
    }

    // Listen for quick view popup opening
    document.addEventListener('theme:popup:open', function(event) {
      const quickView = document.querySelector('.popup-quick-view');
      if (!quickView) return;

      setTimeout(() => {
        const giftSection = quickView.querySelector('.product__gift-selection');
        if (giftSection) {
          initializeGiftInstance(giftSection);
        }
      }, 500);
    });

    // Listen for quick add drawer opening
    document.addEventListener('theme:drawer:open', function(event) {
      setTimeout(() => {
        const quickAdd = document.querySelector('.pswp--quick-add');
        if (!quickAdd) return;

        const giftSection = quickAdd.querySelector('.product__gift-selection');
        if (giftSection) {
          initializeGiftInstance(giftSection);
        }
      }, 500);
    });

    // Backup: listen for form submit
    document.addEventListener('submit', function(event) {
      const form = event.target.closest('form[action="/cart/add"]');
      if (!form) return;

      checkAndAddGift(form);
    });

    // Listen for any dynamically added gift sections
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Check if the node itself is a gift section
            if (node.matches('.product__gift-selection')) {
              initializeGiftInstance(node);
            }
            
            // Check children of added nodes
            const giftSections = node.querySelectorAll('.product__gift-selection');
            giftSections.forEach(section => {
              initializeGiftInstance(section);
            });
          }
        });
      });
    });

    // Observe the entire document for added gift sections
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });